import React, { useState } from 'react';
import { Modal } from 'components/common';
import { MdOpenInNew, MdClose } from 'react-icons/md';
import { prepareRichHtml } from 'helpers/richHtml';
import './DescriptionRenderer.css';

const DescriptionRenderer = (params) => {
  const [showModal, setShowModal] = useState(false);

  if (!params.value) return <span className="tw-text-slate-500 tw-text-sm">No content</span>;

  const cleanedValue = params.value.trim();
  const strippedText = cleanedValue.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
  const shouldTruncate = strippedText.length > 100;
  const truncatedText = shouldTruncate ? strippedText.substring(0, 100) + '...' : strippedText;

  const openModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowModal(true);
  };

  return (
    <>
      <div className="tw-flex tw-items-start tw-gap-2 tw-w-full">
        <div
          className="tw-flex-grow"
          style={{
            lineHeight: '1.5',
            maxHeight: '3em',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            color: '#374151',
            fontSize: '0.8125rem',
          }}
        >
          {truncatedText}
        </div>

        {shouldTruncate && (
          <button
            type="button"
            className="tw-p-0 tw-flex-shrink-0 tw-border-0 tw-bg-transparent tw-text-blue-600"
            onClick={openModal}
            style={{ fontSize: '0.875rem', lineHeight: 1, cursor: 'pointer', paddingTop: '2px' }}
            title="View full content"
          >
            <MdOpenInNew size={14} />
          </button>
        )}
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        className="desc-modal-content"
      >
        <div className="-tw-mx-6 -tw-my-4">
          <div className="desc-modal-header">
            <span className="desc-modal-title">Full Description</span>
            <button
              type="button"
              className="desc-modal-close"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            >
              <MdClose size={18} />
            </button>
          </div>
          <div className="desc-modal-body">
            <div
              className="desc-html-content"
              dangerouslySetInnerHTML={{ __html: prepareRichHtml(cleanedValue) }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DescriptionRenderer;
